<app-master-detail-layout
    [isMobile]="isMobile"
    [showDetail]="showDetail()"
    (backToSidebar)="showDetail.set(false)">
    <app-settings-sidebar sidebarContent #sidebarContent
        [categories]="categories()"
        [selectedSubcategoryId]="isSearching() ? null : selectedSubcategory().id"
        [navigationCount]="navigationCount()"
        [changedSubcategoryIds]="subcategoriesWithChanges()"
        (subcategorySelect)="onSubcategorySelect($event)" />

    <div mainContent #mainContent class="tw-h-full tw-w-full tw-min-h-0 tw-flex tw-flex-col">
        <app-main-base [useGrid]="false" [isMobile]="isMobile" (back)="showDetail.set(false)">
            <span mainTitle>
                @if (isSearching()) {
                    {{ 'SETTINGS.HUB.SEARCH_RESULTS' | translate }}
                } @else {
                    {{ selectedSubcategory().title | translate }}
                }
            </span>

            <ng-container mainActions>
                <app-action-btn variant="stroked" [disabled]="!settingsState.isDirty()" (click)="settingsState.discard()">
                    {{ 'APPLICATION.CANCEL_LABEL' | translate }}
                </app-action-btn>
                <app-action-btn [disabled]="!settingsState.isDirty() || settingsState.hasErrors()" (click)="save()">
                    {{ 'SETTINGS.SETTINGS.SAVE' | translate }}
                </app-action-btn>
            </ng-container>

            <div mainBody>
                @if (settingsState.ready()) {
                    @if (isSearchTooShort()) {
                        <div class="tw-text-sm tw-text-[var(--sys-secondary-text)] tw-mb-3">
                            {{ 'SETTINGS.HUB.SEARCH_MIN_LENGTH' | translate: { count: minSearchLength } }}
                        </div>
                    }
                    @if (isSearching() && cards().length) {
                        <div class="tw-text-sm tw-text-[var(--sys-secondary-text)] tw-mb-3">
                            {{ 'SETTINGS.HUB.SEARCH_SUMMARY' | translate: searchSummaryParams() }}
                        </div>
                    }
                    @if (sectionResults().length) {
                        <div class="tw-mb-4">
                            <app-card [cardTitle]="'SETTINGS.HUB.SECTION_RESULTS' | translate" [fullHeigth]="false">
                                <div class="tw-flex tw-flex-col">
                                    @for (section of sectionResults(); track section.id) {
                                        <div class="tw-flex tw-items-center tw-gap-3 tw-py-3" [attr.data-section]="section.id">
                                            <mat-icon class="tw-text-[var(--sys-secondary-text)]">{{ section.icon }}</mat-icon>
                                            <div class="tw-flex tw-flex-col tw-min-w-0 tw-flex-1">
                                                <span class="tw-font-medium tw-truncate">{{ section.title | translate }}</span>
                                                <span class="tw-text-xs tw-text-[var(--sys-secondary-text)] tw-truncate">
                                                    {{ section.categoryTitle | translate }}
                                                    · {{ 'SETTINGS.HUB.SECTION_SETTINGS_COUNT' | translate: { count: section.settingsCount } }}
                                                </span>
                                            </div>
                                            <button mat-stroked-button type="button" (click)="onSubcategorySelect(section.id)">
                                                {{ 'SETTINGS.HUB.GO_TO_SECTION' | translate }}
                                            </button>
                                        </div>
                                        @if (!$last) {
                                            <mat-divider />
                                        }
                                    }
                                </div>
                            </app-card>
                        </div>
                    }
                    <div class="tw-columns-1 lg:tw-columns-2 tw-gap-4">
                        @for (card of cards(); track card.id) {
                            <div class="tw-break-inside-avoid tw-mb-4" [class.settings-full-width]="card.fullWidth">
                                <app-card [cardTitle]="card.title | translate" [fullHeigth]="false">
                                    @if (card.origin; as origin) {
                                        <button type="button" class="tw-mb-2 tw-p-0 tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-xs tw-text-[var(--sys-primary)] hover:tw-underline"
                                            (click)="onSubcategorySelect(origin.subcategoryId)">
                                            {{ origin.categoryTitle | translate }} › {{ origin.subcategoryTitle | translate }}
                                        </button>
                                    }
                                    <div class="tw-flex tw-flex-col">
                                        @for (group of card.groups; track group.settings[0].id) {
                                            <div [class]="group.settings.length > 1 ? 'tw-flex tw-flex-col sm:tw-flex-row tw-gap-x-4 tw-my-3 tw-px-4 tw-rounded-xl tw-border tw-border-solid tw-border-[var(--sys-divider)]' : 'tw-flex tw-flex-col'">
                                                @for (setting of group.settings; track setting.id) {
                                                    <div class="tw-flex tw-items-center tw-gap-1 tw-py-3" [class.tw-flex-1]="group.settings.length > 1" [class.tw-min-w-0]="group.settings.length > 1" [attr.id]="'setting-' + setting.id"
                                                        role="group" [attr.aria-label]="card.origin ? settingPaths().get(setting.id) : null" [attr.title]="card.origin ? settingPaths().get(setting.id) : null">
                                                        <app-settings-field class="tw-flex-1 tw-min-w-0"
                                                            [setting]="setting"
                                                            [context]="settingsState.context()"
                                                            [value]="valueOf(setting)"
                                                            [disabled]="settingsState.isDisabled(setting)"
                                                            [error]="settingsState.getError(setting)"
                                                            [lookup]="lookup"
                                                            (valueChange)="onValueChange(setting, $event)"
                                                            (actionRun)="runAction($event)" />
                                                        @if (card.origin) {
                                                            <button mat-icon-button type="button" [attr.aria-label]="'SETTINGS.HUB.GO_TO_SETTING' | translate" (click)="goToSetting(card, setting)">
                                                                <mat-icon>my_location</mat-icon>
                                                            </button>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            @if (group.divider) {
                                                <mat-divider />
                                            }
                                        }
                                    </div>
                                </app-card>
                            </div>
                        } @empty {
                            @if (!sectionResults().length) {
                                <div class="tw-text-[var(--sys-secondary-text)]">{{ 'SETTINGS.HUB.NO_RESULTS' | translate }}</div>
                            }
                        }
                    </div>
                }
            </div>
        </app-main-base>
    </div>
</app-master-detail-layout>
